import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=3d607a22&scoped=true&"
import script from "./Draggable.vue?vue&type=script&lang=js&"
export * from "./Draggable.vue?vue&type=script&lang=js&"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=3d607a22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d607a22",
  null
  
)

export default component.exports